export const convertToBackendId = (clientUserId: string | number) => {
	const num =
		typeof clientUserId === 'string' ? parseInt(clientUserId) : clientUserId;
	return ((num % 100) * 10000000000 + num / 100).toFixed(0);
};

export const isValidClientBotId = (id: string | number) => {
	return /^\d{9}42$/.test(id.toString());
};
